import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RootState } from '@app/store/root-state';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { fetchAllFenceResult, postFenceResult } from '@app/store/faxe/fence-result/fence-result.actions';
import { selectFenceResultByRaceGuid } from '@app/store/faxe/fence-result/fence-result.selectos';
import { UniqueIdService } from '@app/facade-services/unique-id-service';
import {
  getOperationStoreStatus
} from '@app/store/client-slices/operation/operation-store-selectors';
import { OperationStoreState } from '@app/store/client-slices/operation/operation-store-state';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { FenceResultPost } from '@app/rest-client/faxe/models/fence-result-post';
import { UserToken } from '@app/services/password/model/user-token';

@Injectable({
  providedIn: 'root'
})
export class FenceResultFacadeService {

  constructor(
    private readonly store: Store<RootState>,
    private readonly uniqueIdService: UniqueIdService) {
  }

  fetchFenceResult(raceGuid: string, requiredSliceState: SliceState, issuer: string): void {
    this.store.dispatch(
      fetchAllFenceResult(
        { raceGuid, requiredSliceState, issuerStack: [issuer] }));
  }

  selectFenceResultByRaceGuid(raceGuid: string, requiredSliceState: SliceState): Observable<FenceResultPost[]> {
    return this.store.pipe(
      select(selectFenceResultByRaceGuid(raceGuid, requiredSliceState)));
  }

  postFenceResult(fenceResult: FenceResultPost[], userToken: UserToken,  issuer: string): Observable<OperationStoreState> {

    const correlationId = this.uniqueIdService.generateUUID();

    const request =  {
      fenceResult,
      raceGuid: userToken.selectedRaceGuid,
      userGuid: userToken.token,
      signature: userToken.signature,
      issuerStack: [issuer],
      correlationId };

    this.store.dispatch(
      postFenceResult(request));

    return this.store.pipe(
      select(getOperationStoreStatus),
      filter(state => state.correlationId === correlationId));
  }

}
